import { HttpEventType } from '@angular/common/http';
import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { base64ToFile } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { AreaService } from 'src/app/area/area.service';
import { Area } from 'src/app/shared/interfaces/area.interface';
import { GroupWordService } from '../service/group-word.service';

@Component({
  selector: 'app-group-word-form',
  templateUrl: './group-word-form.component.html',
  styleUrls: ['./group-word-form.component.css'],
})
export class GroupWordFormComponent implements OnInit {
  formGroup: FormGroup;
  id;
  areas: Area[];
  file: File;
  uploadProgress = 0;

  constructor(
    private groupWordService: GroupWordService,
    private toastr: ToastrService,
    private router: Router,
    private areaSeervice: AreaService
  ) {
    this.formGroup = new FormGroup({
      theme: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
      ]),
      area_id: new FormControl('', Validators.required),
    });
    this.getAreas();
  }

  ngOnInit(): void {}

  add(): Promise<any> {
    return this.groupWordService
      .add(this.formGroup.value)
      .then((res) => {
        this.toastr.success(res.message);
        this.router.navigateByUrl('/palavra');
      })
      .catch((err) => {
        this.toastr.error(err.error.message);
      });
  }

  getAreas(): Promise<any> {
    return this.areaSeervice
      .get()
      .then((res) => {
        this.areas = res;
      })
      .catch((err) => {
        this.toastr.error(err.error.message);
      });
  }

  async selectFile($event) {
    this.file = $event.target.files[0];
    await this.fileToBlod().then((res) => {});
  }

  async send() {
    const { theme, area_id } = this.formGroup.value;
    const formData = new FormData();
    const blob: Blob = await this.fileToBlod();

    formData.append('file', this.file, this.file.name);
    formData.append('theme', theme);
    formData.append('area_id', area_id);

    this.formGroup.disable();
    this.groupWordService.add1(formData).subscribe((event) => {
      if (event.type === HttpEventType.UploadProgress) {
        const percentDone = Math.round((100 * event.loaded) / event.total);
        this.uploadProgress = percentDone;
        this.formGroup.disable();
      }

      if (event.type === HttpEventType.Response && event.status === 201) {
        this.toastr.success(event.body['message']);
        this.uploadProgress = 0;
        this.formGroup.reset();
        this.formGroup.enable();
      }

      if (event.type === HttpEventType.ResponseHeader && event.status !== 201) {
        this.toastr.error('Falha ao enviar documento');
        this.uploadProgress = 0;
        this.formGroup.enable();
      }
    });
  }

  fileToBlod(): Promise<any> {
    return new Promise((resolver, reject) => {
      try {
        const read = new FileReader();
        read.addEventListener('load', (res: ProgressEvent<FileReader>) => {
          resolver(res.target.result);
        });

        read.readAsText(this.file);
      } catch (error) {
        reject(error);
      }
    });
  }
}
